module.exports = __webpack_public_path__ + "static/media/bell.9820b8db.png";